<template>
  <div class="user-exchange-record">
    <myHeader showBack v-show="!isApp">
      <div slot="title">历史记录</div>
    </myHeader>
    <div class="user-exchange-record--card-list" v-if="cardList.length > 0" :style="{ 'margin-top': isApp ? '0' : '44px' }">
      <div class="show-card-name">
        <span class="card-name" @click="cardListShow">{{ card.cardName }}({{ card.cardNum }})</span>
        <span class="triangle"></span>
      </div>

      <div class="card-list-body" v-show="showCardList">
        <div class="card-list-wrap__layer" @click.stop="hideCardList"></div>
        <div class="card-list-wrap">
          <div class="group-can-use" v-if="canUseList.length > 0">
            <div class="title">可用券</div>
            <div
              class="card-list-wrap__item can-use"
              :class="{ selected: item.cardNum == card.cardNum }"
              v-for="item in canUseList"
              :key="item.cardNum"
              @click.stop="selectCard(item)"
            >
              {{ item.cardName }}({{ item.cardNum }})
              <span class="current" v-if="item.cardNum == card.cardNum">当前券</span>
            </div>
          </div>
          <div class="group-can-not-use" v-if="canNotUseList.length > 0">
            <div class="title">不可用券</div>
            <div
              class="card-list-wrap__item not-use"
              :class="{ selected: item.cardNum == card.cardNum }"
              v-for="item in canNotUseList"
              :key="item.cardNum"
              @click.stop="selectCard(item)"
            >
              <div class="card-content" :style="{ color: isInvalidUse(item) ? '#959697' : '#353637' }">
                {{ item.cardName }}({{ item.cardNum }})
                <span class="current" v-if="item.cardNum == card.cardNum">当前券</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="user-exchange-record--record-list" v-if="recordList.length > 0">
      <div class="user-exchange-record--record-item" v-for="bill in recordList" :key="bill.billSeq" @click.stop="toDetail(bill)">
        <div class="name-value line">
          <span class="name">{{ getEventName(bill.businessType) }}</span>
          <span class="value">{{ getBusinessAmount(bill) }}</span>
        </div>
        <div class="date-total line">
          <span class="date">{{ bill.createdAt }}</span>
          <span class="total" v-if="bill.isRecordRemaining === 1">{{ getRemainAmount(bill) }}</span>
        </div>
      </div>
    </div>
    <div class="user-exchange-record--empty-list" v-else>
      <img src="../../../../image/card/record_empty.png" alt="" class="empty-icon" />
      <div class="content">暂无消费记录</div>
    </div>
  </div>
</template>

<script>
import myHeader from '../../../components/header'
import CardService from '../../../service/card'
import { toYuan } from '../../../util/function.js'
import { app } from '../../../util/platform'
import setDocumentTitle from '../../../util/document-title'
export default {
  data() {
    return {
      canUseList: [],
      canNotUseList: [],
      cardList: [],
      card: {
        cardNum: '',
        cardName: '',
        uniqueCardId: '',
      },
      showCardList: false,
      recordList: [],
    }
  },
  components: {
    myHeader,
  },
  computed: {
    isApp() {
      return app.isMZFilm()
    },
  },
  async mounted() {
    if (this.isApp) {
      setDocumentTitle('历史记录')
    }
    console.log('mounted----')
    try {
      const res = await CardService.getCardSimpleList()
      this.cardList = res.list
      res.list.forEach(item => {
        if (item.validFlag === 1) {
          this.canUseList.push(item)
        } else {
          this.canNotUseList.push(item)
        }
      })
      console.log(this.canUseList)
      const cardNum = this.$route.query.cardNum
      const card = res.list.find(v => {
        return v.cardNum === cardNum
      })
      this.card = card ? card : this.canUseList.length > 0 ? this.canUseList[0] : this.canNotUseList[0]

      console.log(this.card)
      this.getCardRecord()
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    cardListShow() {
      this.showCardList = !this.showCardList
    },
    selectCard(card) {
      this.card = card
      this.showCardList = false
      this.$router.replace({
        name: 'exchange-record',
        query: {
          cardNum: this.card.cardNum,
        },
      })
      this.getCardRecord()
    },
    hideCardList() {
      this.showCardList = false
    },
    async getCardRecord() {
      try {
        const res = await CardService.getCardBillList({ cardNum: this.card.cardNum })
        this.recordList = res.billList
      } catch (error) {}
    },
    getEventName(type) {
      let str = ''
      //业务来源，1：消费、4：退款，5：充值，6：扣减（2、3类型订单不返回）98：延期记录、99：过期记录
      switch (type) {
        case 1:
          str = '商城消费'
          break
        case 4:
          str = '售后退还'
          break
        case 5:
          str = '卡券充值'
          break
        case 6:
          str = '卡券扣减'
          break
        case 98:
          str = '延期'
          break
        case 99:
          str = '过期'
          break
        default:
          break
      }
      return str
    },
    formatPrice(num) {
      return toYuan(num)
    },
    toDetail(bill) {
      const record = Object.assign(bill, { cardNum: this.card.cardNum, uniqueCardId: this.card.uniqueCardId })
      this.$store.commit('setCardRecordInfo', record)
      this.$router.push({
        name: 'exchange-record-detail',
      })
    },
    getBusinessAmount(bill) {
      const { businessType, unit, cardCount, cardType, billAmout, cardAmount } = bill
      if (businessType == 98 || businessType == 99) {
        return '0'
      }
      if (unit == 1) {
        return `${cardCount}${cardType == 1 ? '张票' : cardType == 3 ? '份礼包' : ''}`
      } else if (unit == 2) {
        return `${this.formatPrice(cardAmount)}点`
      }
    },
    getRemainAmount(bill) {
      const { cardType, remainingCount, remainingAmount } = bill
      if (cardType == 1) {
        return `${remainingCount}张票`
      } else if (cardType == 2) {
        return `${this.formatPrice(remainingAmount)}点`
      } else if (cardType == 3) {
        return `${remainingCount}份礼包`
      } else {
        return ''
      }
    },
    isInvalidUse(item) {
      if(!item) return false 
      return (item.cardCount === 0 && item.cardBalance === 0 ) || item.validFlag === 2 || item.validFlag === 3 || item.validFlag === 5
    }
  },
}
</script>

<style lang="less" scoped>
@import '../../../../stylesheet/variable.less';

.user-exchange-record {
  &--card-list {
    color: #2e2f30;
    font-size: 15px;
    padding: 0 10px;
    position: relative;

    .show-card-name {
      height: 45px;
      line-height: 45px;
    }
    .triangle {
      position: relative;
      &:after {
        content: ' ';
        width: 0;
        height: 0;
        border-top: 6px solid #2f2f30;
        border-right: 6px solid transparent;
        border-left: 6px solid transparent;
        border-radius: 9px;
        position: absolute;
        top: 50%;
        transform: translate(5px, -50%);
      }
    }
    .card-list-body {
      position: relative;
      .card-list-wrap__layer {
        position: absolute;
        z-index: 2;
        top: 0;
        left: -15px;
        width: 100vw;
        height: calc(~'100vh - 90px');
      }
    }
    .card-list-wrap {
      position: absolute;
      top: 0;
      left: 0;
      background: #fff;
      min-width: 220px;
      max-width: 300px;
      z-index: 3;
      box-shadow: 0px 8px 16px 0px #cecece;
      max-height: 234px;
      overflow-y: auto;
      border-radius: 8px;
      &__item {
        color: #2e2f30;
        font-size: 15px;
        line-height: 21px;
        position: relative;
        &:after {
          .setBottomLine(#ededed);
        }
        .over-date {
          margin-top: 8px;
          font-size: 12px;

          line-height: 17px;
        }
      }
      .can-use {
        padding: 15px 11px;
      }
      .not-use {
        padding: 15px 11px;
      }
      .current {
        width: 38px;
        height: 18px;
        background: rgba(253, 79, 11, 0.1);
        border-radius: 4px;
        text-align: center;
        line-height: 18px;
        font-size: 10px;
        color: #fd4f0b;
        display: inline-block;
        margin-left: 20px;
      }
      .selected {
        background: rgba(253, 79, 11, 0.05);
      }

      .group-can-use {
        .title {
          font-size: 16px;
          color: #191a1b;
          font-weight: bold;
          padding: 20px 11px 4px;
        }
      }
      .group-can-not-use {
        border-top: 10px solid #f4f4f4;
        .title {
          font-size: 16px;
          color: #191a1b;
          font-weight: bold;
          padding: 20px 11px 4px;
        }
      }
    }
  }
  &--record-list {
    background: #fff;
    padding: 0 10px;
  }
  &--empty-list {
    margin-top: 140px;
    text-align: center;
    .empty-icon {
      width: 113px;
      height: 87px;
      display: inline-block;
    }
    .content {
      margin-top: 24px;
      color: #bdc0c5;
      font-size: 14px;
    }
  }
  &--record-item {
    position: relative;
    padding: 15px 0;
    &:after {
      .setBottomLine(#ededed);
    }
    .line {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .name-value {
      color: #2e2f30;
      font-size: 15px;
    }
    .date-total {
      margin-top: 3px;
      color: #bdc0c5;
      font-size: 13px;
    }
  }
}
</style>
